import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// A hash target inside a lazily-loaded route doesn't exist until that chunk
// has been fetched and rendered, so keep looking for a short window instead
// of giving up after one frame.
const HASH_TIMEOUT_MS = 2000;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    let frame;
    const deadline = performance.now() + HASH_TIMEOUT_MS;

    const look = () => {
      let target = null;
      try {
        target = document.querySelector(hash);
      } catch (_) {
        // A hash that isn't a valid selector is not ours to scroll to.
        return;
      }

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (performance.now() < deadline) {
        frame = requestAnimationFrame(look);
      }
    };

    frame = requestAnimationFrame(look);
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
